// extracted by css-extract-rspack-plugin
export default {"cls1":"GrantsMarketingButton-cls1_zsx","cls2":"GrantsMarketingButton-cls2_SBa GrantsMarketingButton-cls1_zsx"};